export default class Config {
    static BACKEND_URL =
        process.env.NODE_ENV === 'production'
            ? 'https://sandbox.api.perroquet.beamcove.com/v1'
            : 'http://localhost:3001/v1';
}
